import React from 'react';
import { clsx } from 'clsx';

export const IntegrationItem = ({
  icon,
  name,
  onClick,
  disabled = false,
  icons = undefined,
}: {
  // Image URL of the integration logo.
  icon?: string;
  name?: string;
  onClick?: () => void;
  disabled?: boolean;
  // Small channel badges (chat, email) shown in the corner.
  icons?: React.ReactNode[];
}) => {
  return (
    <li>
      <button
        type="button"
        className={clsx(
          disabled && 'pointer-events-none opacity-50',
          'flex py-6 px-4 border border-[#E3E6E8] rounded-sm-5 shadow relative cursor-pointer',
          'w-full h-full text-left',
        )}
        onClick={disabled ? () => {} : onClick}
      >
        <div className="flex gap-2 items-center">
          <div className="h-[18px] w-[18px]">
            <img alt="Integration icon" src={icon} width={'50px'} />
          </div>
          <p className="text-sm font-semibold text-ebony font-jamjuree">{name}</p>
        </div>
        <div className="absolute bottom-2 right-4">
          {icons?.map((icon, index) => (
            <React.Fragment key={`${name}-${index}`}>{icon}</React.Fragment>
          ))}
        </div>
      </button>
    </li>
  );
};
